<template>
  <div class="content--sinoreg boxDocs">
    <object v-if="documentoUrl"
            class="embed-preview embed-responsive"
            :data="documentoUrl"
            type="application/pdf">
      <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando <a :href="documentoUrl">aqui</a>.</p>
    </object>
  </div>
</template>

<script>
  /* services */
  import DocumentosService from "@/services/Documentos"

  export default {
    name: 'VisualizarArquivos',
    data () {
      return {
        documentoUrl: null,
      }
    },
    beforeMount () {
      this.getData()
    },
    methods: {
      async getData () {
        loader({ text: 'Carregando documento...', active: true })
        try {

          const arquivo = await DocumentosService.getDocumento(this.$route.params.id, this.$route.params.origem, 'N')
          let blob = new Blob([arquivo], { type: 'application/pdf' })
          let url = window.URL.createObjectURL(blob)

          this.documentoUrl = url
        } catch (e) {
          objSwal.error.title = 'Erro'
          objSwal.error.text = 'Erro ao procurar o arquivo, favor entrar em contato com o suporte'

          loader({ text: '', active: false })
          Swal.fire(objSwal.error).then(res => res)
        }

        loader({ text: '', active: false })
      }
    }
  }
</script>

<style lang="scss">
  @import '../../scss/_utilities/_exports';

  .boxDocs {}
</style>
